import { useMobileNativeShare } from '#src/app/pages/petitionDetails/shared/hooks';
import type { ShareAction } from '#src/app/shared/hooks/share';

type UsePetitionHeadingMobileReturn = ModelHookResult<{
	shareAction: ShareAction<'mobileNativeShare'> | null;
}>;

export function usePetitionHeadingMobile(): UsePetitionHeadingMobileReturn {
	const shareAction = useMobileNativeShare('petition_show_image');

	return {
		data: {
			shareAction,
		},
	};
}
